module.exports = require("core-js/modules/es.array.filter.js");